import React, { CSSProperties } from 'react'
import cx from 'classnames'
import { Header } from '../header'
import { SEO } from '../seo'

const Styles = require('./layout.module.styl')

type Props = {
  contentStyle?: CSSProperties
  headerCls?: string
  layoutCls?: string
}

class Layout extends React.Component<Props> {
  render() {
    const { children, contentStyle, layoutCls } = this.props
    return (
      <div className={cx(Styles['container'], layoutCls)}>
        <Header headerCls={this.props.headerCls} />
        <SEO />
        <div style={contentStyle} className={Styles['content']}>
          {children}
        </div>
        {/* <Footer /> */}
      </div>
    )
  }
}

export default Layout
